import React, { Component } from 'react'
import './vehicle.css'
import Grid from '@material-ui/core/Grid'
import ItemCard from '../../Reusable/ItemCard'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import LocationOn from '@material-ui/icons/LocationOn'
import LocationCity from '@material-ui/icons/LocationCity'
import Person from '@material-ui/icons/Person'
import { Button } from '@material-ui/core'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import getLoginId from '../../../utils/getLoginId'
import fetchClientPublicIp from '../../../utils/fetchClientPublicIp'
import Loader from '../../common/Loader'

const GET_LOGIN_TOKEN = gql`
  query getClientLoginToken(
    $clientid: Int!
    $clientIp: String
    $source: String
    $performedByLoginId: Int
    $performedByUsername: String
  ) {
    getClientLoginToken(
      id: $clientid
      clientIp: $clientIp
      source: $source
      performedByLoginId: $performedByLoginId
      performedByUsername: $performedByUsername
    ) {
      token
    }
  }
`
const GET_CLIENT_DOMAIN = gql`
  query getPartnerDomainConfig($loginId: Int!) {
    domain: getPartnerDomainConfig(loginId: $loginId)
  }
`

// export default class VehicleRegistration extends Component {
class VehicleRegistration extends Component {
  loginCustomer = clientId => async () => {
    try {
      const clientIp = await fetchClientPublicIp()
      const { data } = await this.props.client.query({
        query: GET_LOGIN_TOKEN,
        variables: {
          clientid: clientId,
          // clientid: 1969
          clientIp,
          source: 'admin-frontend',
          performedByLoginId: getLoginId(),
          performedByUsername: localStorage.getItem('username')
        }
      })

      if (data) {
        const { data: domain } = await this.props.client.query({
          query: GET_CLIENT_DOMAIN,
          variables: {
            loginId: getLoginId()
          }
        })

        let clienturl =
          'https://' +
          domain.domain +
          '/?token=' +
          data.getClientLoginToken.token
        let win = window.open(clienturl, '_blank')
        win.focus()
      }
    } catch (error) {
      console.error('GraphQL Query Error: ', error)
    }
  }

  render() {
    return (
      <Grid
        item
        xs={12}
        container
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <ItemCard
            className="details"
            style={{
              width: '100%',
              margin: '0 auto'
            }}
          >
            <Grid container className="content1">
              <Grid item xs={12} sm={12}>
                {/* <Typography variant="title">
                  <IconButton>
                    <Person color="primary" />
                  </IconButton>
                  {this.props.clientName}
                </Typography> */}
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Grid item xs>
                    <Typography variant="title">
                      <IconButton>
                        <Person color="primary" />
                      </IconButton>
                      {this.props.clientName}
                    </Typography>
                  </Grid>
                  <Grid item>
                    {this.props.loginId ? (
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.loginCustomer(this.props.loginId)}
                      >
                        LOGIN PREVIEW
                      </Button>
                    ) : (
                      <Loader />
                    )}
                  </Grid>
                </Grid>
                <Typography component="p">
                  <IconButton>
                    <LocationOn color="primary" />
                  </IconButton>
                  {this.props.address}
                </Typography>
                <Typography component="p">
                  <IconButton>
                    <LocationCity color="primary" />
                  </IconButton>
                  {this.props.city}
                </Typography>
              </Grid>
            </Grid>
          </ItemCard>
        </Grid>
        {/* <Grid item xs={4}>
          <ItemCard
            className="details"
            style={{
              width: '50%',
              margin: '0 auto'
            }}
          >
            <Grid container spacing={16} alignItems="center">
              <Grid item>
                <Typography variant="body2">Amount:</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body1">4000/-</Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2">No of Devices Assigned:</Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography variant="body1">40</Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  No of Devices Registered:
                </Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography variant="body1">40</Typography>
              </Grid>
            </Grid>
          </ItemCard>
        </Grid> */}
      </Grid>
    )
  }
}
export default withApollo(VehicleRegistration)



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/ClientDetails.jsx